import { useEffect, useState } from 'react'
import { MenuItems } from '../enums/MenuItems'
import { TenantDto } from '../api/tenant/models/TenantDto'
import tenantApi from '../api/tenant/TenantApi'
import { Link } from 'react-router-dom'
import { Pages } from '../Pages'
import LayoutSingleView from '../components/layout/LayoutSingleView'

function Tenants(): React.JSX.Element {
    const [tenants, setTenant] = useState<TenantDto[]>([])

    useEffect(() => {
        const fetchData = async () => {
            const tenantData = await tenantApi.getAll()
            setTenant(tenantData.tenants)
        }
        fetchData()
    }, [])

    return (
        <LayoutSingleView activeMenuItem={MenuItems.Tenants}>
            <div>
                <div className="flex items-center justify-between">
                    <h2 className="page-title">Tenants</h2>
                    <Link
                        to={Pages.CreateNewTenant}
                        className="flex items-center justify-center w-12 h-12 rounded-full bg-[#153bab] text-white text-xl font-bold border-none no-underline cursor-pointer relative transition-all duration-300 ease shadow-md overflow-hidden group hover:w-40 hover:h-12 hover:rounded-[25px] hover:bg-blue-600"
                    >
                        <span className="opacity-100 transition-opacity duration-300 group-hover:opacity-0">
                            +
                        </span>
                        <span className="absolute whitespace-nowrap text-base opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                            Add New Tenant
                        </span>
                    </Link>
                </div>
                <table className="main-table">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tenants.map((tenant) => (
                            <tr key={tenant.id}>
                                <td>{tenant.id}</td>
                                <td>
                                    <Link
                                        className="link-text"
                                        to={`${Pages.Tenant}?id=${tenant.id}`}
                                    >
                                        {tenant.name}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </LayoutSingleView>
    )
}

export default Tenants
